var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ua",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gold",
    d: "M0 0h512v512H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0057b8",
    d: "M0 0h512v256H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUa);
export default __webpack_public_path__ + "static/media/ua.af1d11dab17044ee2036a635e89196cd.svg";
export { ForwardRef as ReactComponent };